import apiClient from "./base.service";

export default {
    async index() {
        return await apiClient.get(`/apikey`);
    },
    async create(data) {
        return await apiClient.post(`/apikey`, data);
    },
    async remove(id) {
        return await apiClient.delete(`/apikey/${id}`);
    }
}